export default function useModifiers(
  baseCssClass: any,
  modifiers: {
    length: any;
    map: (arg0: (modifier: any) => string) => {
      (): any;
      new (): any;
      toString: { (): string; new (): any };
    };
  },
) {
  if (modifiers.length) {
    const modifierCssClasses = modifiers
      .map((modifier) => ` ${baseCssClass}--${modifier}`)
      .toString()
      .replace(/,/g, '');
    return `${baseCssClass}${modifierCssClasses}`;
  }
  return baseCssClass;
}
